import Content from "../services/Content";

const debounce = require('lodash/debounce');

export default {

    props: ['autocompleteUrl', 'initialSearchQuery', 'lang'],

    data: () => ({
        searchQuery: null,
        results: null,
        isLoading: false,
        selectedIndex: -1,
    }),

    mounted: function() {
        if (this.initialSearchQuery) {
            this.searchQuery = this.initialSearchQuery;
        }
    },

    methods: {

        onKeyPress: function (ev) {
            if (this.isLoading || !this.results) {
                return;
            }

            switch (ev.key) {
                case 'ArrowUp':

                    this.selectedIndex--;

                    if (this.selectedIndex < -1) {
                        this.selectedIndex = -1;
                    }

                    if (this.selectedIndex === -1) {
                        this.$refs.input.setSelectionRange(-1, -1);
                        return;
                    }

                    ev.preventDefault();

                    break;

                case 'ArrowDown':

                    this.selectedIndex++;

                    if (this.selectedIndex > (this.results.length - 1)) {
                        this.selectedIndex = this.results.length - 1;
                    }

                    break;

                case 'Enter':

                    this.isLoading = true;

                    if (this.selectedIndex >= 0) {
                        let page = this.results[this.selectedIndex];
                        let href = page.href;

                        this.results = null;

                        window.location = href;

                        ev.preventDefault();
                        return;
                    }

                    break;
            }
        },

        onQueryChange: debounce(function (ev) {
            this.isLoading = true;

            return Content.AutocompleteByName(this.searchQuery, this.lang)
                .then((pages) => {
                    this.results = pages.map((page) => {

                        if (page.lead && page.lead.length > 200) {
                            page.lead = page.lead.substring(0, 200) + '...';
                        }

                        return page;

                    });
                    this.isLoading = false;
                })
                .catch((err) => {
                    this.results = null;
                    this.isLoading = false;
                });

        }, 250)

    }

}
